import { TeaserManager } from "./TeaserManager.js";

TeaserManager.use();
